export default __webpack_public_path__ + "static/media/calendar2.973cd5ee.png";